import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=6b42082b&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=6b42082b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42082b",
  null
  
)

export default component.exports